import { useMediaQuery } from '@/hooks/useMediaQuery'
import React from 'react'

interface Props {
  title: string
  icon: React.ReactNode
  children: React.ReactNode
  count: number
  sectionRef?: (node: HTMLHeadingElement | null) => void
  onClickScroll?: () => void
}

const SearchResultSection: React.FC<Props> = ({
  title,
  icon,
  children,
  count,
  sectionRef,
  onClickScroll,
}) => {
  const mobileCheck = useMediaQuery('(max-width: 640px)')

  return (
    <>
      <h3
        ref={sectionRef}
        onClick={onClickScroll}
        className={`${mobileCheck ? 'text-base' : 'text-lg'} font-normal  ml-2 flex items-center  mb-2 cursor-pointer`}
      >
        <span className='pr-[10px]  py-1'>{icon}</span>
        {title}
        <span className='ml-2 inline-flex items-center text-xs font-normal justify-center w-auto px-padding-xl h-[17px] bg-info-dim-light text-info-forground rounded-radius-full'>
          {count}
        </span>
      </h3>
      <ul className='space-y-4'>{children}</ul>
      <hr className='my-1 border-t-[1px] border-secondary-border' />
    </>
  )
}

export default SearchResultSection
